/* [sc-48247] Etichetta della variante di un articolo.

   Sullo stesso codice fornitore convivono più articoli che differiscono solo
   per materiale/finitura/colore e prezzo — 2.796 codici su 7.612 nel solo
   listino Berloni, fino a 5 varianti ciascuno. Negli elenchi (listini,
   magazzino) erano righe identiche con numeri diversi, che l'operatore legge
   come un bug dei dati.

   `material`, `color` e `finish` non sono alternativi ma complementari, e il
   fornitore quasi sempre ne dichiara uno o due: `IDROLAM A` è un materiale,
   `LACCATO OPACO B1` una finitura, `CRISTALLO LUCIDO S1` entrambi. Da qui
   l'etichetta unica invece di tre colonne mezze vuote in ogni tabella.

   [sc-48250] `color` è entrato dopo: Catalano lo valorizza su 1.252 righe su
   1.328 e senza di lui la colonna "Variante" mostrava "Satinato" o niente,
   cioè la finitura senza la cosa che distingue davvero le varianti. L'ordine
   è materiale → colore → finitura, dal supporto al trattamento; su Berloni,
   l'unico altro listino che usa `color`, i tre campi non si sovrappongono mai
   (93 righe, tutte con `material` e `finish` NULL), quindi nessuna etichetta
   esistente cambia.

   Il separatore "·" è puramente visivo: non ricostruisce una sintassi del
   fornitore, che non esiste. */

export function variantLabel(item) {
  const parts = [item?.material, item?.color, item?.finish]
    .map((v) => (v == null ? "" : String(v).trim()))
    .filter(Boolean);
  return parts.length ? parts.join(" · ") : null;
}

export default variantLabel;
